// 外見に登録されている動画を ZIP にまとめる（MP4 は圧縮済みのため無圧縮で格納する）
import { VIDEO_SLOTS } from "./appearanceDefs";

const CRC_TABLE = (() => {
    const table = new Uint32Array(256);
    for (let n = 0; n < 256; n++) {
        let c = n;
        for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        table[n] = c >>> 0;
    }
    return table;
})();

export const crc32 = (data) => {
    let crc = 0xffffffff;
    for (let i = 0; i < data.length; i++) crc = CRC_TABLE[(crc ^ data[i]) & 0xff] ^ (crc >>> 8);
    return (crc ^ 0xffffffff) >>> 0;
};

const dosTime = (d) => (d.getHours() << 11) | (d.getMinutes() << 5) | (d.getSeconds() >> 1);
const dosDate = (d) => ((d.getFullYear() - 1980) << 9) | ((d.getMonth() + 1) << 5) | d.getDate();

/**
 * 無圧縮の ZIP を作る
 * @param {{ name: string, data: Uint8Array }[]} entries
 * @returns {Uint8Array}
 */
export const buildStoreZip = (entries, date = new Date()) => {
    const encoder = new TextEncoder();
    const time = dosTime(date);
    const day = dosDate(date);
    const items = entries.map((e) => ({ name: encoder.encode(e.name), data: e.data, crc: crc32(e.data) }));
    const localSize = items.reduce((sum, it) => sum + 30 + it.name.length + it.data.length, 0);
    const centralSize = items.reduce((sum, it) => sum + 46 + it.name.length, 0);
    const out = new Uint8Array(localSize + centralSize + 22);
    const view = new DataView(out.buffer);
    let p = 0;

    // ファイル名は UTF-8（汎用フラグ bit 11）
    const writeCommon = (it) => {
        view.setUint16(p, 20, true); p += 2;            // 展開に必要なバージョン
        view.setUint16(p, 0x0800, true); p += 2;        // フラグ
        view.setUint16(p, 0, true); p += 2;             // 無圧縮
        view.setUint16(p, time, true); p += 2;
        view.setUint16(p, day, true); p += 2;
        view.setUint32(p, it.crc, true); p += 4;
        view.setUint32(p, it.data.length, true); p += 4;
        view.setUint32(p, it.data.length, true); p += 4;
        view.setUint16(p, it.name.length, true); p += 2;
        view.setUint16(p, 0, true); p += 2;             // 拡張フィールド長
    };

    const offsets = items.map((it) => {
        const offset = p;
        view.setUint32(p, 0x04034b50, true); p += 4;
        writeCommon(it);
        out.set(it.name, p); p += it.name.length;
        out.set(it.data, p); p += it.data.length;
        return offset;
    });

    const centralStart = p;
    items.forEach((it, i) => {
        view.setUint32(p, 0x02014b50, true); p += 4;
        view.setUint16(p, 20, true); p += 2;            // 作成したバージョン
        writeCommon(it);
        view.setUint16(p, 0, true); p += 2;             // コメント長
        view.setUint16(p, 0, true); p += 2;             // ディスク番号
        view.setUint16(p, 0, true); p += 2;             // 内部属性
        view.setUint32(p, 0, true); p += 4;             // 外部属性
        view.setUint32(p, offsets[i], true); p += 4;
        out.set(it.name, p); p += it.name.length;
    });

    view.setUint32(p, 0x06054b50, true); p += 4;
    view.setUint16(p, 0, true); p += 2;
    view.setUint16(p, 0, true); p += 2;
    view.setUint16(p, items.length, true); p += 2;
    view.setUint16(p, items.length, true); p += 2;
    view.setUint32(p, centralSize, true); p += 4;
    view.setUint32(p, centralStart, true); p += 4;
    view.setUint16(p, 0, true);
    return out;
};

/** ZIP に入れる動画（登録済みのものだけ。どの種別か分かるよう名前の頭に種別を付ける） */
export const collectArchiveTargets = (appearance) => VIDEO_SLOTS
    .filter((slot) => appearance.assets[slot.key])
    .map((slot) => ({ name: `${slot.short}_${appearance.assets[slot.key].file_name}`, url: appearance.assets[slot.key].url }));

export const archiveFileName = (appearance) => `外見動画_${appearance.id}_${appearance.name.replace(/[\\/:*?"<>|]/g, '_')}.zip`;

/** 動画を取得して ZIP にし、ブラウザで保存する */
export const downloadAppearanceVideos = async (appearance) => {
    const targets = collectArchiveTargets(appearance);
    const entries = [];
    for (const target of targets) {
        const response = await fetch(target.url);
        if (!response.ok) throw new Error(`${target.name}: ${response.status}`);
        entries.push({ name: target.name, data: new Uint8Array(await response.arrayBuffer()) });
    }
    const blob = new Blob([buildStoreZip(entries)], { type: "application/zip" });
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = archiveFileName(appearance);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(objectUrl);
};
